<template>
  <div class="receipt-list tab-table p-2">
    <ReceiptTable/>
  </div>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";
  import ReceiptTable from "../../../receipt/ReceiptTable";

  const {mapState} = createNamespacedHelpers('customer/customerView');
  const {mapActions: receiptMapActions} = createNamespacedHelpers('receipts');

  export default {
    name: "ReceiptList",
    components: {ReceiptTable},
    methods: {
      ...receiptMapActions(['updateTableSource'])
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
      }),
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'customer',
        extraFilters: {customer_uuid: this.customer.uuid}
      });
    }
  }
</script>

<style lang="scss" scoped>

</style>
